import React from "react";

//styles
import "./styles.scss";

//assets
import assets from "../../../Assets/index";

const Header = ({ onToggle, pageName = "Dashboard", sidebarOpen }) => {
  return (
    <div className="header-container">
      <div className="leftSideIconsContainer">
        <p>{pageName}</p>
      </div>
      <div className="rightSideIconsContainer">
        {/* <img
          className="notificationIcon"
          src={assets.Icons.notificationIcon}
          alt="notificationIcon"
        /> */}
        <img
          src={assets.Images.kgInternationalLogo}
          alt="kgInternationalLogo"
        />
      </div>
    </div>
  );
};

export default Header;
